import { render, staticRenderFns } from "./SavedViews.vue?vue&type=template&id=91800354&scoped=true"
import script from "./SavedViews.vue?vue&type=script&lang=js"
export * from "./SavedViews.vue?vue&type=script&lang=js"
import style0 from "./SavedViews.vue?vue&type=style&index=0&id=91800354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91800354",
  null
  
)

export default component.exports